// @ts-strict-ignore

import styled from "styled-components";
import { Text } from "@hubble/web";

export const PrivacyLinkText = styled.span`
  text-decoration: underline;
  color: white;
`;

export const BannerText = styled(Text.Body).attrs({
  size: "xs",
  color: "white"
})`
  width: 100%;
  padding-bottom: 24px;
  margin: 0;
`;

export const ModalHeader = styled(Text.Heading).attrs({ size: "md" })`
  margin-top: 0;
`;

export const ModalContent = styled.div`
  margin-left: 25px;
`;

export const LabelEmphasis = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const Section = styled.div`
  margin-bottom: 16px;
`;

export const ModalFooter = styled.footer`
  justify-content: flex-end;
  display: flex;
`;

export const CancelButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.textColors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  cursor: pointer;
  margin-right: 32px;
`;
